import { Badge } from '@warp-ds/react';
import { getEventConfig } from './eventConfig';

export const EventBanner = ({ event }: { event: string }) => {
    const config = getEventConfig(event);
    if (!config) return null;

    const { src, alt, text } = config.banner;
    return (
        <div className="mb-16 relative">
            <img src={src} alt={alt} className="w-full rounded-8" />
            <Badge variant="info" className="absolute bottom-0 left-0 px-8 rounded-tr-8 rounded-bl-8 rounded-tl-0 rounded-br-0">
                {text}
            </Badge>
        </div>
    );
};
